import {Tag} from "../../../general/Tag.tsx";
import {InfoTooltip} from "../../../general/InfoTooltip.tsx";
import {MoneyLabel} from "../../../general/MoneyLabel.tsx";
import {toDecimalFromMoney} from "../../../../lib/Money.ts";
import {
    bankBalanceCheckLabel,
    bankBalanceTooltipText,
    selectBankBalanceMismatches,
} from "../utils/bankBalanceChecks.ts";
import type {BankBalanceCheck} from "../types/types.ts";

interface Props {
    checks: BankBalanceCheck[] | null;
}

export function BankBalanceChecks({checks}: Props) {
    const mismatches = selectBankBalanceMismatches(checks);
    if (mismatches.length === 0) {
        return null;
    }

    return (
        <div className="mt-4 flex flex-wrap items-center gap-3">
            <span className="text-sm font-medium text-gray-700">Bankafstemming</span>
            {mismatches.map((check) => (
                <span key={check.bank_account_id} className="flex items-center gap-1.5">
                    <Tag variant="warning" size="xs">
                        {bankBalanceCheckLabel(check)}: Banksaldo wijkt af
                    </Tag>
                    {check.difference && (
                        <span className="text-xs text-gray-500">
                            <MoneyLabel
                                value={toDecimalFromMoney(check.difference)}
                                currency={check.currency}
                                showCurrency={true}
                                colorAid={true}
                            />
                        </span>
                    )}
                    <InfoTooltip text={bankBalanceTooltipText(check)} position="top"/>
                </span>
            ))}
        </div>
    );
}
